import {SmoothScroll} from '../services/SmoothScroll';
import CompanyTabsItem = anm.CompanyTabsItem;

class Company implements ng.IComponentController {
    activeTab: anm.CompanyTabsName;
    onScreen                    = '50';
    tabs: anm.CompanyTabsItem[] = [
        {
            name: 'about',
            scrollTo: '.about-section',
            offset: 100
        },
        {
            name: 'wave',
            scrollTo: '.press-product-section.wave',
            offset: 60
        },
        {
            name: 'studio',
            scrollTo: '.press-product-section.studio',
            offset: 60
        },
        {
            name: 'press',
            scrollTo: '.press-section',
            offset: 60
        }
    ];

    private onScreenObservers: Function[] = [];

    constructor(private $stateParams: anm.CompanyStateParams,
                private $rootScope: ng.IRootScopeService,
                private $state: ng.ui.IStateService) {
        if (this.$stateParams.tab) {
            setTimeout(() => {
                this.changeTab(this.$stateParams.tab);
                this.observeOnScreen();
            }, 500);
        } else {
            this.observeOnScreen();
        }
    }

    $onDestroy() {
        this.onScreenObservers.forEach(f => f());
    }

    changeTab(nextTabName: anm.CompanyTabsName) {
        const nextTab  = this.tabs.filter((tab) => tab.name === nextTabName)[0];
        this.activeTab = nextTab.name;
        this.scroll(nextTab);
        this.stateGo(nextTab.name);
    }

    private stateGo(nextTabName: anm.CompanyTabsName) {
        const params = {
            tab: nextTabName
        };

        const options = {
            notify: false,
            location: 'replace'
        };

        this.$state.go(
            this.$state.current,
            params,
            options
        );
    }

    private scroll(tab: anm.CompanyTabsItem) {
        const scrollElement = document.querySelector(tab.scrollTo);
        const offset        = tab.offset || 0;
        const scrollSvc     = new SmoothScroll(scrollElement, offset);
        scrollSvc.scroll();
    }

    private observeOnScreen() {
        const cb = _.debounce((tab: anm.CompanyTabsItem) => {
            this.activeTab = tab.name;
            this.stateGo(tab.name);
        }, 300);

        this.tabs.forEach((tab) => {
            const observer = this.$rootScope.$on(`onScreen:${tab.name}`, () => cb(tab));
            this.onScreenObservers.push(observer);
        });
    }
}

angular.module('animatronApp.company', []).component('company', {
    controller: Company,
    templateUrl: require('company.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/company.ts